// Libraries
import has from 'lodash/has'
import React from 'react'
// Components
import BtnLoginSocial from '../index'
// Hooks
import { useAuth } from '../../../hooks/use-auth'
import { useRouter } from '../../../hooks/use-router'
import { useTranslation } from '../../../hooks/use-translation'
// Utils
import { analytics } from '../../../utils/firebase'

const BtnLoginFacebook = () => {
  const auth = useAuth()
  const router = useRouter()
  const { translate } = useTranslation()

  let channelType, channelId

  if (has(router.query, 'channelType') && has(router.query, 'channelId')) {
    channelType = router.query.channelType
    channelId = router.query.channelId
  }

  return (
    <BtnLoginSocial
      text={translate('c-btn-login-social.title-facebook')}
      backgroundColor="#3b5998"
      textColor="#fff"
      iconSrc="/images/ic-facebook.svg"
      onClick={async () => {
        await auth.signinWithFacebook(channelType, channelId)
        router.push('/')
        analytics.logEvent('vhod_facebook')
      }}
    />
  )
}

export default BtnLoginFacebook
